import { render, staticRenderFns } from "./MasteUserSection.vue?vue&type=template&id=710a1678&scoped=true"
import script from "./MasteUserSection.vue?vue&type=script&lang=js"
export * from "./MasteUserSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710a1678",
  null
  
)

export default component.exports